<template>
  <teleport to="#modals">
    <div class="modal is-active is-layout-fixed" v-if="isActive" @keydown.esc=answerNAY tabindex="0" ref="modalroot">
      <div class="modal-background"></div>
      <div class="modal-card" :style="widthStyle">
        <header class="modal-card-head">
          <p class="modal-card-title title mb-0 ml-5">{{ headingText }}</p>
          <div class="buttons is-right">
            <button class="button" aria-label="close" @click="answerNAY" style="box-shadow: none !important; border: 0px;">
              <span class="icon is-medium">
                <i class="fas fa-2x fa-window-close"></i>
              </span>
            </button>
          </div>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <slot></slot>
        </section>
        <footer class="modal-card-foot" v-if="hasButtons">
          <div class="is-flex is-flex-wrap-wrap is-justify-content-space-between is-fullwidth" style="width: 100%; gap: 0.5rem;">
            <div>
              <button
                v-if="showCancel"
                class="pyroll-button dark-blue-bg font-white"
                @click="answerNAY"
              >
                {{ cancelButtonText }}
              </button>
            </div>

            <div>
              <button
                v-if="showOk"
                class="pyroll-button green-bg"
                @click="answerOK"
              >
                {{ okButtonText }}
              </button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </teleport>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'ModalDialog',
  props: {
    showOk: {
      type: Boolean,
      default: true,
    },
    okButtonText: {
      type: String,
      default: 'Kyllä',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    cancelButtonText: {
      type: String,
      default: 'Peruuta',
    },
    headingText: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '640px'
    },
    minWidth: {
      type: String,
      default: '640px'
    }
  },
  emits: ['modal-result-ok', 'modal-result-cancel'],
  data() {
    return {
      isActive: false,
      resolve: null,
      reject: null,
    }
  },
  computed: {
    hasButtons() {
      return this.showOk || this.showCancel
    },
    widthStyle() {
      return {
        width: this.width,
        'min-width': this.minWidth
      }
    }
  },
  methods: {
    showModal() {
      document.documentElement.style.overflow = 'hidden'
      // promise based function to show dialog
      this.isActive = true
      this.$nextTick().then(() => {
        this.$refs.modalroot.focus()
      })
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    answerOK(...args) {
      document.documentElement.style.overflow = 'auto'
      this.$emit('modal-result-ok')
      this.isActive = false
      if (this.resolve != null) {
        return this.resolve(...args)
      }
    },
    answerNAY(...args) {
      document.documentElement.style.overflow = 'auto'
      this.$emit('modal-result-cancel')
      this.isActive = false
      if (this.reject != null) {
        return this.reject(...args)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.button.is-secondary.is-inverted:hover {
    background-color: initial;
}

.is-layout-fixed {
    position: fixed !important;
}

.modal {
  z-index: 100;
  .modal-card {
    @media (max-width: 768px) {
      min-width: 0px !important;
      width: 95% !important;
      max-height: 90vh;
      overflow-y: auto;
    }
  }
}

.buttons {
  margin-left: 15px;
  .button {
    min-width: 50px;
    text-align: center;
    display: block;
  }
}

.modal-card-head {
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  padding: 0px;
}
.modal-card-foot {
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  padding: 5px;
}
</style>
